'use client';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface HourlyData {
  hour: number;
  appearedCount: number;
  disappearedCount: number;
}

interface HourlyChartProps {
  data: HourlyData[];
}

export default function HourlyChart({ data }: HourlyChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="flex h-[400px] items-center justify-center text-sm text-gray-500">
        データがありません
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="hour"
          tickFormatter={(h) => `${h}時`}
        />
        <YAxis />
        <Tooltip
          labelFormatter={(h) => `${h}時台`}
          formatter={(value, name) => {
            const label = name === 'appearedCount' ? '新着空室' : '申込み済み';
            return [`${value}件`, label];
          }}
        />
        <Legend
          formatter={(value: string) => {
            if (value === 'appearedCount') return '新着空室';
            if (value === 'disappearedCount') return '申込み済み';
            return value;
          }}
        />
        <Line
          type="monotone"
          dataKey="appearedCount"
          name="appearedCount"
          stroke="#2563eb"
          strokeWidth={2}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
        <Line
          type="monotone"
          dataKey="disappearedCount"
          name="disappearedCount"
          stroke="#dc2626"
          strokeWidth={2}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
